import type { GetMembersResponse } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'

import type { FormValues } from './modules/NewMessageModal/types'

export type Supporter = Awaited<
  ReturnType<typeof MembershipsDirectMessagesApiClient.getDirectMessagesConversation>
>['data']['supporter']

export type Messages = Awaited<
  ReturnType<typeof MembershipsDirectMessagesApiClient.getDirectMessagesConversationMessages>
>['data']['messages']

export type Conversations = Awaited<
  ReturnType<typeof MembershipsDirectMessagesApiClient.getDirectMessagesConversationPreviews>
>['data']['conversations']

export type SendDirectMessageParameters = Parameters<
  typeof MembershipsDirectMessagesApiClient.sendDirectMessagesMessage
>[0]

export type User = {
  id: number
  name: string
  avatarUrl?: string
}

export type ChatCreateState = {
  formValues: FormValues
  members?: GetMembersResponse['members']
}

export enum ChatCreateParams {
  memberId = 'memberId',
}
